import React, { useState } from "react";
import "../../Assets/styles/RSVP.css";

const RSVPSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    attending: "yes",
    additionalGuests: 0,
    guests: [],
    restrictions: "",
    comments: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGuestsChange = (e) => {
    const numberOfGuests = parseInt(e.target.value, 10);

    const updatedGuests = Array.from({ length: numberOfGuests }, (_, index) => {
      return (
        formData.guests[index] || {
          firstName: "",
          lastName: "",
          child: false,
          childType: "",
          chairType: "",
          restrictions: "",
        }
      );
    });

    setFormData((prev) => ({
      ...prev,
      additionalGuests: numberOfGuests,
      guests: updatedGuests,
    }));
  };

  const handleGuestDetailsChange = (index, field, value) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      guests: updatedGuests,
    }));
  };

  const handleGuestCheckboxChange = (index, checkboxField, isChecked) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[index][checkboxField] = isChecked;

    if (checkboxField === "child" && !isChecked) {
      updatedGuests[index].childType = "";
      updatedGuests[index].chairType = "";
    }

    setFormData((prev) => ({
      ...prev,
      guests: updatedGuests,
    }));
  };

  const handleGuestChildTypeChange = (index, value) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[index].childType = value;

    setFormData((prev) => ({
      ...prev,
      guests: updatedGuests,
    }));
  };

  const handleGuestChairTypeChange = (index, value) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[index].chairType = value;

    setFormData((prev) => ({
      ...prev,
      guests: updatedGuests,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setSubmitError("");

    const payload = new URLSearchParams();
    payload.append("data", JSON.stringify(formData));

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbyWmN80TQwd9_Cjqs2yIARS65M7l6frh2w_sqXa6sJmjEem06y2D-a1rffII_N2rNV6tQ/exec",
        {
          method: "POST",
          mode: "no-cors",
          body: payload,
        }
      );

      setSubmitSuccess(true);
    } catch (error) {
      console.error("Erro ao enviar RSVP:", error);
      setSubmitError("Ocorreu um erro ao enviar o RSVP. Tenta novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rsvp-section" id="rsvp">
      <div className="rsvp-header">
        <h2 className="rsvp-title">RSVP</h2>
        <p className="rsvp-subtitle">
          Confirma a tua presença no nosso grande dia
        </p>
        <p className="rsvp-subtitle rsvp-subtitle-detail">
          Até dia 14 de junho
        </p>
      </div>

      {submitSuccess ? (
        <div className="rsvp-success-card">
          <div className="success-icon-wrapper">
            <div className="success-checkmark">✓</div>
          </div>
          <h3 className="rsvp-success-title">RSVP enviado com sucesso</h3>
          <p className="rsvp-success-text">
            Obrigado pela tua confirmação. Mal podemos esperar por celebrar este
            dia contigo.
          </p>
        </div>
      ) : (
        <div className="rsvp-form-shell">
          {isSubmitting && (
            <div className="rsvp-loading-overlay" aria-live="polite" aria-busy="true">
              <div className="rsvp-spinner"></div>
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className={`rsvp-form ${isSubmitting ? "is-submitting" : ""}`}
          >
            <div className="form-row">
              <input
                type="text"
                name="firstName"
                placeholder="Primeiro Nome"
                value={formData.firstName}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
              <input
                type="text"
                name="lastName"
                placeholder="Último Nome"
                value={formData.lastName}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                name="restrictions"
                placeholder="Restrições alimentares"
                value={formData.restrictions}
                onChange={handleChange}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <p className="title-text">Estarás presente?</p>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="attending"
                    value="yes"
                    checked={formData.attending === "yes"}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  Sim
                </label>
                <label>
                  <input
                    type="radio"
                    name="attending"
                    value="no"
                    checked={formData.attending === "no"}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  Não
                </label>
              </div>
            </div>

            {formData.attending === "yes" && (
              <>
                <div className="form-group">
                  <label htmlFor="additionalGuests">
                    <p>Quantas pessoas extra vais trazer?</p>
                  </label>
                  <select
                    name="additionalGuests"
                    value={formData.additionalGuests}
                    onChange={handleGuestsChange}
                    disabled={isSubmitting}
                  >
                    <option value={0}>0</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                  </select>
                </div>

                {formData.additionalGuests > 0 &&
                  formData.guests.map((guest, index) => (
                    <div className="guest-card" key={index}>
                      <p className="guest-card-title">Convidado {index + 1}</p>

                      <div className="form-row">
                        <input
                          type="text"
                          placeholder={`Convidado ${index + 1} Primeiro Nome`}
                          value={guest.firstName}
                          onChange={(e) =>
                            handleGuestDetailsChange(index, "firstName", e.target.value)
                          }
                          required
                          disabled={isSubmitting}
                        />
                        <input
                          type="text"
                          placeholder={`Convidado ${index + 1} Último Nome`}
                          value={guest.lastName}
                          onChange={(e) =>
                            handleGuestDetailsChange(index, "lastName", e.target.value)
                          }
                          required
                          disabled={isSubmitting}
                        />
                      </div>

                      <div className="form-row guest-second-row">
                        <input
                          type="text"
                          name="restrictions"
                          placeholder="Restrições alimentares"
                          value={guest.restrictions}
                          onChange={(e) =>
                            handleGuestDetailsChange(index, "restrictions", e.target.value)
                          }
                          disabled={isSubmitting}
                        />

                        <div className="guest-child-row">
                          <div className="checkbox-group">
                            <div className="checkbox-category">
                              <label htmlFor={`child-guest-${index}`}>
                                <input
                                  id={`child-guest-${index}`}
                                  type="checkbox"
                                  checked={guest.child || false}
                                  onChange={(e) =>
                                    handleGuestCheckboxChange(
                                      index,
                                      "child",
                                      e.target.checked
                                    )
                                  }
                                  disabled={isSubmitting}
                                />
                                Criança
                              </label>
                            </div>
                          </div>

                          {guest.child && (
                            <div className="child-options-wrapper">
                              <div className="child-option-block">
                                <p className="child-option-title">Faixa etária</p>
                                <div className="child-radio-group">
                                  <label>
                                    <input
                                      type="radio"
                                      name={`childType-${index}`}
                                      value="0_3"
                                      checked={guest.childType === "0_3"}
                                      onChange={(e) =>
                                        handleGuestChildTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    0-3 anos
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      name={`childType-${index}`}
                                      value="4_10"
                                      checked={guest.childType === "4_10"}
                                      onChange={(e) =>
                                        handleGuestChildTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    4-10 anos
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      name={`childType-${index}`}
                                      value="11_plus"
                                      checked={guest.childType === "11_plus"}
                                      onChange={(e) =>
                                        handleGuestChildTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    11+ anos
                                  </label>
                                </div>
                              </div>

                              <div className="child-option-block">
                                <p className="child-option-title">Tipo de cadeira</p>
                                <div className="child-radio-group">
                                  <label>
                                    <input
                                      type="radio"
                                      name={`chairType-${index}`}
                                      value="sem_cadeira"
                                      checked={guest.chairType === "sem_cadeira"}
                                      onChange={(e) =>
                                        handleGuestChairTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    Não preciso
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      name={`chairType-${index}`}
                                      value="cadeira_normal"
                                      checked={guest.chairType === "cadeira_normal"}
                                      onChange={(e) =>
                                        handleGuestChairTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    Cadeira normal
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      name={`chairType-${index}`}
                                      value="cadeira_alta"
                                      checked={guest.chairType === "cadeira_alta"}
                                      onChange={(e) =>
                                        handleGuestChairTypeChange(index, e.target.value)
                                      }
                                      disabled={isSubmitting}
                                    />
                                    Cadeira alta
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            )}

            <div className="form-group">
              <label htmlFor="comments">
                <p>Algum comentário ou preocupação extra?</p>
              </label>
              <textarea
                name="comments"
                placeholder="Escreve aqui a tua mensagem"
                value={formData.comments}
                onChange={handleChange}
                disabled={isSubmitting}
              />
            </div>

            {submitError && <p className="rsvp-error-message">{submitError}</p>}

            <button type="submit" className="rsvp-button" disabled={isSubmitting}>
              {isSubmitting ? "A enviar..." : "Submeter"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default RSVPSection;